
export const topBannerControl = (): void => {
  const topBannerWrapper = document.querySelector('.js-topBanner') as unknown as HTMLElement

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!topBannerWrapper || !bodyElement) {
    return
  }

  const animateBanner = (bannerElement: HTMLElement): void => {
    bannerElement.classList.add('-active')

    function splitWords (selector: string, delayTimer = 300, callback?: () => void, timeout = 0) {
      let quote = bannerElement.querySelector(selector) as unknown as HTMLElement
      if (!quote) {
        return
      }
      // Replace all non-BRs
      let modifiedText = quote.innerText.replace(/(<(?!br\s*\/?)[^>]+>)/ig, '')
      modifiedText = modifiedText.replace(/\n/ig, ' <br> ')
      let quotewords = modifiedText.split(' ') as any

      let wordCount = quotewords.length
      quote.innerHTML = ''
      for (let i = 0; i < wordCount; i++) {
        if (quotewords[i] === '<br>') {
          quote.innerHTML += '<br>'
          continue
        }
        quote.innerHTML += `<span class="-fadeout">${quotewords[i]}</span>`
        if (i < quotewords.length - 1) {
          quote.innerHTML += ' '
        }
      }
      quotewords = bannerElement.querySelectorAll(`${selector} span`)

      setTimeout(() => {
        fadeWords(quotewords, delayTimer, bannerElement, callback)
      }, timeout)
    }

    function fadeWords (quotewords: HTMLElement[], delayTimer: number, slide: HTMLElement, callback?: () => void) {
      let delay = 0
      Array.prototype.forEach.call(quotewords, function (word: HTMLSpanElement) {
        delay += delayTimer
        word.style.transitionDelay = `${delay}ms`
        word.style.transitionDuration = `${delayTimer + delayTimer / 2}ms`
        if (slide.classList.contains('-active')) {
          word.classList.remove('-fadeout')
        }
      })

      setTimeout(() => {
        if (callback) {
          callback()
        }
      }, delay + delayTimer + delayTimer / 2)
    }

    function animateExtraImage (selector: string) {
      let extraImage = bannerElement.querySelector(selector) as unknown as HTMLElement
      if (!extraImage) {
        return
      }

      setTimeout(() => {
        extraImage.classList.remove('-fadeOut')
      }, 650)
    }

    animateExtraImage('.js-topBanner-extraImage')

    splitWords('.js-topBanner-title', 300)

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    splitWords('.js-topBanner-subTitle', 200, () => {}, 1000)
  }

  animateBanner(topBannerWrapper)
}
